import { CreateElement } from 'vue/types/vue';
import { VNode } from 'vue';
// @ts-ignore
import FaIcon from '@/components/FaIcon.vue';
import { sanitizeHTML } from '@/components/section-preview/utils/sanitizer';
import { WebService } from '@/components/section-preview/utils/web-service';

export function renderLabel(
  h: CreateElement,
  label: string,
  iconName: string = null
) {
  const children = [];

  // label icon
  if (iconName) {
    const $icon = h(FaIcon, { props: { iconName } });
    children.push(h('div', { staticClass: 'label-icon' }, [$icon]));
  }

  // label text
  children.push(h('div', { staticClass: 'label-text' }, label));

  return h('div', { staticClass: 'label-wrap' }, children);
}

export function renderValue(
  h: CreateElement,
  wrapper: string,
  value: string | number | VNode[],
  klass: string = null,
  isHTML: boolean = false
) {
  const isNumber = !isNaN(Number(value));
  let staticClass = 'value-wrap';
  if (klass) staticClass += ` ${klass}`;
  if (isNumber) staticClass += ` value-integer-${value}`;
  if (isHTML) staticClass += ` cv-preview-html ck-content`;

  return isHTML
    ? h('div', { staticClass, domProps: { innerHTML: value } })
    : h(wrapper, { staticClass }, Array.isArray(value) ? value : `${value}`);
}

// FIXME use env var
const DEFAULT_AVATAR_URL =
  'https://proff-local.s3-ap-northeast-1.amazonaws.com/images/default-profile-icon.png';

export function renderAvatar(
  h: CreateElement,
  url: string,
  {
    width = 20,
    height = 20,
    klass = '',
  }: { width?: number; height?: number; klass?: string }
) {
  const src = url || DEFAULT_AVATAR_URL;
  return h('img', {
    attrs: { src, alt: 'avatar', width, height },
    staticClass: klass,
  });
}

export function renderHTML(html: string) {
  return sanitizeHTML(html) || null;
}

export function renderDate(
  h,
  {
    year,
    month,
    day,
  }: {
    year?: number;
    month?: number;
    day?: number;
  }
) {
  const children = [];

  if (year) children.push(h('div', { staticClass: 'year' }, `${year}`));
  if (month) children.push(h('div', { staticClass: 'month' }, `${month}`));
  if (day) children.push(h('div', { staticClass: 'day' }, `${day}`));

  return children;
}

// TODO rename
export function autoLink(h: CreateElement, url: string) {
  return h(
    'a',
    { attrs: { href: url, rel: 'noopener noreferrer', target: '_blank' } },
    [url]
  );
}
// TODO rename
export function linkTo(
  h: CreateElement,
  url: string,
  text: string,
  iconName: string
) {
  const icon = h(FaIcon, { props: { iconName } });
  const children = [
    h('div', { staticClass: 'link-icon' }, [icon]),
    h('div', { staticClass: 'link-icon-label' }, text),
  ];

  return h(
    'a',
    {
      staticClass: 'icon-link',
      attrs: { href: url, rel: 'noopener', target: '_blank' },
    },
    children
  );
}

export function renderLink(h: CreateElement, url: string) {
  let faIconText = 'chrome';

  const snsUri = new WebService(url);
  // Text
  const text = snsUri.serviceName() ? snsUri.path() : url;

  // Icon
  if (snsUri.isGithub()) {
    faIconText = 'github';
  } else if (snsUri.isFacebook()) {
    faIconText = 'facebook';
  } else if (snsUri.isTwitter()) {
    faIconText = 'twitter';
  } else if (snsUri.isLinkedin()) {
    faIconText = 'linkedin';
  } else if (snsUri.isInstagram()) {
    faIconText = 'instagram';
  }

  const children = [];

  children.push(h('div', { staticClass: 'plane' }, [autoLink(h, url)]));
  children.push(
    h('div', { staticClass: 'icon-link-wrap' }, [
      linkTo(h, url, text, faIconText),
    ])
  );

  return children;
}
